import { handleError } from "../../../util/errors";
import apiBase from "../../api";
import { FETCH_TAXPAYERS, FETCH_COMPANY_INFO } from "../../urls";

class TaxpayersService {
  fetchTaxpayers = async (page, perPage, term = "") => {
    try {
      const resposne = await apiBase.get(FETCH_TAXPAYERS(page, perPage, term));
      if (resposne.status !== 200) throw new Error();
      const { data } = resposne.data;
      return { data };
    } catch (err) {
      throw handleError(err, "Error fetching taxpayers");
    }
  };

  fetchCompanyInfo = async (id) => {
    try {
      const response = await apiBase.get(FETCH_COMPANY_INFO(id));
      if (response.status !== 200) throw new Error();
      return response.data;
    } catch (err) {
      throw handleError(err, "Error fetching company information");
    }
  };
}

export default new TaxpayersService();
